import { render, staticRenderFns } from "./Mainmenu.vue?vue&type=template&id=3aff37c1&scoped=true&"
import script from "./Mainmenu.vue?vue&type=script&lang=js&"
export * from "./Mainmenu.vue?vue&type=script&lang=js&"
import style0 from "./Mainmenu.vue?vue&type=style&index=0&id=3aff37c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff37c1",
  null
  
)

export default component.exports